/**
 * @param {string} name 子应用名称，会被拼入 dom id 属性中，应唯一
 * @param {string} entry 可访问到子应用的 url
 * @param {string | string[]} activeRule 不应有冲突，且具备唯一性
 */

export default [
  {
    name: '项目管理',
    entry: '/pe-pg-fe-baton/index.html',
    activeRule: '/baton',
  },
  {
    name: '个人中心',
    entry: '/pe-pg-fe-personal/index.html',
    activeRule: '/personal',
  },
  {
    name: '设备管理-换电站',
    entry: '/pe-powerpro-fe-swap/index.html',
    activeRule: '/equipment/powerswap',
  },
  {
    name: '档案portal',
    entry: '/pe-powerpro-fe-archive/index.html',
    activeRule: '/archive',
  },
  {
    name: '设备管理-桩(含桩群)',
    entry: '/pe-powerpro-fe-powercharger/index.html',
    activeRule: '/equipment/powercharger',
  },
  {
    name: '服务诊断',
    entry: '/pe-pg-fe-service-dx/index.html',
    activeRule: '/service-dx',
  },
  {
    name: '通用设备管理 White Label 版本',
    entry: '/pe-pg-fe-equipment/index.html',
    activeRule: '/equipment/whitelabel',
  },
  {
    name: '工单管理',
    entry: '/pe-powerpro-fe-worksheet/index.html',
    activeRule: '/worksheet',
  },
  {
    name: 'LOCA 配置管理',
    entry: '/pe-powerpro-fe-loca/index.html',
    activeRule: '/loca',
  },
  {
    name: '订阅管理',
    entry: '/pe-powerpro-fe-subscribe/index.html',
    activeRule: '/subscribe',
  },
  {
    name: '满意度管理',
    entry: '/pe-powerpro-fe-satisfaction/index.html',
    activeRule: '/satisfaction',
  },
  {
    name: '表单设计',
    entry: '/pe-powerpro-fe-nvwa/index.html',
    activeRule: '/nvwa',
  },
  {
    name: '工单列表',
    entry: '/pe-powerpro-fe-bohu/index.html',
    activeRule: '/bohu',
  },
  {
    name: '工单详情',
    entry: '/pe-pg-fe-workflow/index.html',
    activeRule: '/workflow',
  },
  {
    name: '语言包管理',
    entry: '/pe-powerpro-fe-zhenghe/index.html',
    activeRule: '/zhenghe',
  },
  {
    name: '字典管理',
    entry: '/pe-powerpro-fe-mozi/index.html',
    activeRule: '/mozi',
  },
  {
    name: 'Pegion管理',
    entry: '/pe-powerpro-fe-pegion/index.html',
    activeRule: '/pegion',
  },
  {
    name: 'OCC 事件管理',
    entry: '/pe-powerpro-fe-occ/index.html',
    activeRule: '/occ',
  },
  {
    name: '能量管理',
    entry: '/pe-powerpro-fe-eco/index.html',
    activeRule: '/eco',
  },
  {
    name: '能量场站管理',
    entry: '/pe-pg-fe-ecopro/index.html',
    activeRule: '/ecopro',
  },
  {
    name: '物模型',
    entry: '/pe-powerpro-fe-prime/index.html',
    activeRule: '/prime',
  },
  {
    name: 'ApaaS',
    entry: '/pe-powerpro-fe-design/index.html',
    activeRule: '/design',
  },
  {
    name: 'ApaaS 2.0',
    entry: '/pe-pg-fe-apaas-designer/index.html',
    activeRule: '/apaas-designer',
  },
  {
    name: '适配器',
    entry: '/pe-powerpro-fe-adapter/index.html',
    activeRule: '/adapter',
  },
  {
    name: '任务管理',
    entry: '/pe-powerpro-fe-task/index.html',
    activeRule: '/task',
  },
  {
    name: 'itr',
    entry: '/pe-pg-fe-itr/index.html',
    activeRule: '/itr',
  },
  {
    name: '选址管理',
    entry: '/pe-powerpro-fe-luban/index.html',
    activeRule: '/luban',
  },
  {
    name: '续航升级',
    entry: '/pe-pg-fe-battery-upgrade/index.html',
    activeRule: '/battery-upgrade',
  },
  {
    name: 'OCC大屏业务',
    entry: '/pe-pg-fe-occ-dashboard/index.html',
    activeRule: '/occ-dashboard',
  },
  {
    name: '运营-发票管理',
    entry: '/pe-powerpro-fe-baas/index.html',
    activeRule: '/baas',
  },
  {
    name: '社区',
    entry: '/pe-powerpro-fe-community/index.html',
    activeRule: '/community',
  },
  {
    name: '备件管理',
    entry: '/pe-powerpro-fe-spare/index.html',
    activeRule: '/spare',
  },
  {
    name: '委外管理',
    entry: '/pe-pg-fe-outsource/index.html',
    activeRule: '/outsource',
  },
  {
    name: '盲盒活动',
    entry: '/pe-pg-fe-cmo-blind-box/index.html',
    activeRule: '/cmo-blind-box',
  },
  {
    name: 'Finder人员查询管理平台',
    entry: '/pe-powerpro-fe-finder/index.html',
    activeRule: '/finder',
  },
  {
    name: '加电旅程',
    entry: '/pe-powerpro-fe-powertrip/index.html',
    activeRule: '/powertrip',
  },
  {
    name: '路书2.0',
    entry: '/pe-powerpro-fe-guidebook/index.html',
    activeRule: '/guidebook',
  },
  {
    name: '设备管理-智能电表',
    entry: '/pe-powerpro-fe-emeter/index.html',
    activeRule: '/equipment/emeter',
  },
  {
    name: '卡券管理',
    entry: '/pe-powerpro-fe-coupon/index.html',
    activeRule: '/coupon',
  },
  {
    name: '远程升级',
    entry: '/pe-powerpro-fe-redrabbit/index.html',
    activeRule: '/redrabbit',
  },
  {
    name: '家充桩',
    entry: '/pe-pg-fe-thor/index.html',
    activeRule: '/thor',
  },
  {
    name: '飞书中台',
    entry: '/pe-pg-fe-carrier/index.html',
    activeRule: '/carrier',
  },
  {
    name: '语音质检',
    entry: '/pe-pg-fe-call-recording/index.html',
    activeRule: '/call-recording',
  },
  {
    name: '服务岛',
    entry: '/pe-service-hub-fe/index.html',
    activeRule: '/service-hub',
  },
  {
    name: '通知管理',
    entry: '/pe-pg-fe-pigeon/index.html',
    activeRule: '/pigeon',
  },
  {
    name: '测试面板',
    entry: '/pe-pg-fe-debug-panel/index.html',
    activeRule: '/debug-panel',
  },
  {
    name: '工具平台',
    entry: '/pe-pg-fe-tools/index.html',
    activeRule: '/tools',
  },
  {
    name: '规则引擎',
    entry: '/pe-pg-fe-rule-engine/index.html',
    activeRule: '/rule-engine',
  },
  {
    name: '数据看板',
    entry: '/pe-pg-fe-prime-kanban/index.html',
    activeRule: '/prime-kanban',
  },
  {
    name: 'ltc',
    entry: '/pe-pg-fe-ltc/index.html',
    activeRule: '/ltc',
  },
  {
    name: '换电运营',
    entry: '/pe-cloud-saas-fe-som/index.html',
    activeRule: '/som',
  },
  {
    name: 'Dome平台',
    entry: '/pe-pg-fe-dome/index.html',
    activeRule: '/dome',
  },
  {
    name: '河图平台',
    entry: '/pe-pg-fe-hetu/index.html',
    activeRule: '/hetu',
  },
  {
    name: '智能运维',
    entry: '/pe-pg-fe-aiops/index.html',
    activeRule: '/aiops',
  },
  {
    name: 'LTO数据大屏',
    entry: '/pe-pg-fe-lto-stat/index.html',
    activeRule: '/lto-stat',
  },
]
